import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Root, SidePanel, SidePanelContent, Title } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { getSidepanelTitleKey } from '../utils/getSidepanelTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const shouldShowIllustration = currentStep => {
  return [Step.LandingPage, Step.CodeVerification, Step.Password, Step.ResendEmail, Step.Name].includes(currentStep);
};
export const SidePanelLayoutViewContainer = ({
  children,
  currentStepNumber,
  customLogo,
  totalSteps
}) => {
  const {
    isDesktop
  } = useResponsiveness();
  const {
    currentStep
  } = useCurrentStep();
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const isOAuthFlow = useSelector(isOAuthSignup);
  const isPreVerificationStep = shouldShowIllustration(currentStep);
  const shouldShowIllustrationSidePanel = isPreVerificationStep || currentStep === Step.LoadingPage && !isOAuthFlow;
  const {
    sidePanelTitleKey,
    titleOptions
  } = getSidepanelTitleKey();
  return /*#__PURE__*/_jsxs(Root, {
    currentStepNumber: currentStepNumber,
    customLogo: customLogo,
    totalSteps: totalSteps,
    children: [isDesktop && /*#__PURE__*/_jsx(SidePanel, {
      children: /*#__PURE__*/_jsxs(SidePanelContent, {
        children: [shouldShowIllustrationSidePanel && /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "1600",
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: isTrellisThemeEnabled ? '136px' : '200px',
            isThemeable: true,
            name: isTrellisThemeEnabled ? 'success-green' : 'content-strategy',
            width: isTrellisThemeEnabled ? '136px' : '200px'
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockStart: isTrellisThemeEnabled ? '500' : '100',
            textAlign: "center",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: sidePanelTitleKey,
              options: titleOptions
            })
          })]
        }), !shouldShowIllustrationSidePanel && /*#__PURE__*/_jsx(Title, {
          message: "sidepanel.title"
        })]
      })
    }), children]
  });
};